<template>
    <div>
        <vggrid  :random="Math.floor(Math.random() * 999999)" ref="xGrid" :list="pqcitemCrossList" tableheight="600" flexname="" :cols="cols"
                :showfooter="false" :showPage="false" :resizable="true"  :mergeRow='mergeRow'
        >
            <!--<template slot="btn" v-if="isEdit">-->
                <!--<vxe-button class="vxe-btn" @click="save" :loading="btnLoading">保存</vxe-button>-->
            <!--</template>-->
        </vggrid>
        <div class="expqc-footbtn" v-if="isEdit">
            <vxe-button type='primary' class="vxe-btn" @click="save" :loading="btnLoading">保存</vxe-button>
        </div>
        <div class="split-line"></div>
        <div class="expqc-container">
        <vggrid :list="pqcesList" :random="Math.floor(Math.random() * 999999)" flexname="" :cols="pqcesCols"  :canbeEdit="isEdit?true : false"
                :showfooter="false" :showPage="false" :resizable="true" :editRules="isEdit?editRules:{}"
        >
            <template slot="btn">
                <div class="expqc-topbtn">
                    <div class="expqc-topbtn-title">我的预审结论</div>
                    <div class="expqc-topbtn-btn" v-if="isEdit">
                        <vxe-button type='primary' class="vxe-btn" @click="submit" :loading="btnLoading">提交</vxe-button>
                    </div>
                </div>
            </template>
        </vggrid>
        </div>
    </div>
</template>
<script>
  import request from '@/utils/request'
  import vggrid from '../../views/common/vggrid'
  import utils from '../../assets/js/utils'
  import common from '@/mixin/common'
  export default {
    name: 'exPqcCheckIndex',
    mixins: [common],
    components: {vggrid},
    props: {
      activeName: {}
    },
    data () {
      return {
        project: {},
        list: [],
        selectList: [],
        pqcitemcheckList: [],
        psuComList: [],
        pqcitemCrossList: [],
        pqcesList: [],
        btnLoading: false,
        model: {},
        isEdit: true,
        mergeRow:['pqcitemchecktypedesc'],
        editRules: {
          'pqcescdesc': [
            {max: 40, message: '最多输入255个字符'}
          ]
        },
        pqcesCols: [
          {field: 'comfullname', fieldtype: 'C', title: '供应商', calculExpr: '', addNewRowFlg: false, width: 280},
          {field: 'pqcesresultdesc', fieldtype: 'C', title: '检查结果', calculExpr: '', addNewRowFlg: false, width: 100},
          // {field: 'pqcescdesc', fieldtype: 'C', title: '检查意见', calculExpr: '', editRender: { name: 'input'}},
          { title: '检查意见 ', showOverflow: true,
            slots: {
              default: 'default',
              default: ({row}) => {
                if (this.isEdit) {
                  return [
                    <input style="width: 100%;height: 30px;box-sizing: border-box;border-radius: 4px;border: 1px solid #DCDFE6;color: #606266;display: inline-block;padding: 0 5px;"
                  value={row.pqcescdesc}  onChange={this.inputChange.bind(this, row)}></input>
                ]
                } else {
                  return row.pqcescdesc
                }
              }
            }
          }
        ],
        cols: []
      }
    },
    async created () {
      await this.getModel()
      this.getCols()
      await this.getPqcitemCrossList()
    },
    watch: {
      activeName () {
        console.log(this.activeName)
        if(this.activeName === 'aysdb') {
          this.getCols()
          this.getPqcitemCrossList()
        }
      }
    },
    methods: {
      fileClick (col, item) {
        this.downFile(item.appendurl)
      },
      inputChange (row, e) {
        row.pqcescdesc = e.target.value
      },
      async initPqcitemcheck () {
        console.log(44433)
        await request({
          url: 'expert/insertPqcitemcheck',
          method: "post",
          data: {
            projectid: this.$store.getters.expertLoginUser.pexpertprojectid,
            pexpertid: this.$store.getters.expertLoginUser.pexpertid
          }
        })
      },
      // 结果汇总表的提交
      submit () {
        let index = this.pqcesList.findIndex(v => !v.pqcesresultdesc)
        if (index > -1) {
          this.$message.warning('请先进行资格性/符合型检查!')
          return
        }
        this.$confirm('检查完成，提交后，不允许再次检查?', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(async() => {
          let data = await request({
            url: 'expert/insertPqces',
            method: "post",
            data: {
              pexpertid: this.$store.getters.expertLoginUser.pexpertid,
              projectid: this.$store.getters.expertLoginUser.pexpertprojectid,
              list: this.pqcesList
            }
          })
          if (data.issuccess === 1) {
            this.$message.success('保存成功')
            this.isEdit = false
            // this.$emit('change')
          } else {
            this.$message.error('保存失败')
          }
        })
      },
      // 检查结果保存
      async save () {
        if(this.selectList.length !== this.pqcitemcheckList.length) {
          this.$message.warning('请先进行资格性/符合型检查!')
          return
        }
        let data = await request({
          url: 'expert/updatePqcIemCheck',
          method: "post",
          data: {pexpertid: this.$store.getters.expertLoginUser.pexpertid, pqccheckusertype: 2, list: this.selectList}
        })
        if (data.issuccess === 1) {
          this.$message.success('保存成功')
          await this.setPqcesList()
        } else {
          this.$message.error('保存失败')
        }
      },
      // 交叉表的数据
      async getPqcitemCrossList () {
        this.pqcitemCrossList = []
        // this.cols = [
        //   {field: 'pqcitemchecktypedesc', fieldtype: 'C', title: '审查分类', calculExpr: '', addNewRowFlg: false, width: 100},
        //   {
        //     field: 'pqcitemcheckcontent', fieldtype: 'C', title: '审查内容', calculExpr: '', addNewRowFlg: false,
        //   },
        //   {field: 'pqcitemcheckdemand', fieldtype: 'C', title: '采购文件要求', calculExpr: '', addNewRowFlg: false}
        // ]
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/expert/getPqcitemCrossByProjectId',
          params: {
            projectid: this.$store.getters.expertLoginUser.pexpertprojectid,
            pexpertid: this.$store.getters.expertLoginUser.pexpertid
          }
        })
        this.pqcitemCrossList = res.pqcitemList
        this.pqcitemcheckList = res.pqcitemcheckList
        this.psuComList = res.psuList
        await this.setCrossCols(res)
        await this.setPqcesList()
        this.loading = false
      },
      // 我的预审结论数据
      async setPqcesList() {
        await this.getPqcesList()
        if (this.pqcesList.length) {
          this.isEdit = false
        } else {
          this.isEdit = true
          if (!this.selectList.length) {
            this.selectList = this.pqcitemcheckList
          }
          this.pqcesList = this.psuComList.map(v => {
            let result = this.selectList.length ? this.getPsuPqcesResultDesc(v) : null
            return {
              psuid: v.psuid,
              pqcescomid: v.psucomid,
              comfullname: v.comfullname,
              pqcesprojectid: v.psuprojectid,
              pqcesresult: result,
              pqcesresultdesc: result ? (result === '1' ? '通过':'不通过') : '',
              pqcescdesc: null,
              pqcesexpertid: this.$store.getters.expertLoginUser.pexpertid,
              pqcesusertpye: 2
            }
          })
        }
      },
      // 评审人对供应商做检查的过程中，把结果值返回到汇总表
      getPsuPqcesResultDesc (item) {
        // 供应商通过的检查项数
        let pass = this.selectList.filter(v => +v.pqcitemcheckcomid === +item.psucomid && +v.pqcitemcheckresult === 1)
        // 供应商不通过的检查项数
        let faile = this.selectList.filter(v => +v.pqcitemcheckcomid === +item.psucomid &&  +v.pqcitemcheckresult === 2)
        // 供应商的所有检查项
        let selectComList = this.selectList.filter(v => +v.pqcitemcheckcomid === +item.psucomid)
        if (pass.length === selectComList.length && !faile.length) {
          // '通过'
          return '1'
        } else {
          if ((faile.length + pass.length) === selectComList.length) {
            if (faile.length) {
              // '不通过'
              return '2'
            } else {
              return ''
            }
          } else {
            return  ''
          }
        }
      },
      // 获取已检查结果，把结果值说明返回交叉表
      getCrossCheckResultDesc (item) {
        // 供应商通过的检查项数
        let pass = this.pqcitemcheckList.filter(v => +v.pqcitemcheckpqcitemid === +item.pqcitemid && +v.pqcitemcheckcomid === +item.psucomid && +v.pqcitemcheckresult === 1)
        // 供应商不通过的检查项数
        let faile = this.pqcitemcheckList.filter(v => +v.pqcitemcheckpqcitemid === +item.pqcitemid &&  +v.pqcitemcheckcomid === +item.psucomid &&  +v.pqcitemcheckresult === 2)
        // 供应商的所有检查项
        let selectComList = this.pqcitemcheckList.filter(v => +v.pqcitemcheckpqcitemid === +item.pqcitemid &&  +v.pqcitemcheckcomid === +item.psucomid)
        if (pass.length === selectComList.length && !faile.length) {
          // '通过 1'
          return '通过'
        } else {
          if ((faile.length + pass.length) === selectComList.length) {
            if (faile.length) {
              // '不通过 2'
              return '不通过'
            } else {
              return ''
            }
          } else {
            return  ''
          }
        }
      },
      // 设置交叉表的表头
      async setCrossCols (res) {
        if (res.psuList.length) {
          for(let i=0;i<res.psuList.length;i++) {
            let item = res.psuList[i]
            this.cols.push({
              title:item.comfullname,
              children: [
                {
                  // title: item.appendfilename,
                  slots: {
                    default: 'default',
                    default: ({row}) => {
                      if (this.isEdit) {
                        return [
                          <input type="radio" name={row.pqcitemid+''+item.comid+''} checked={this.getCrossCheckResultDesc({pqcitemid: row.pqcitemid, psucomid: item.comid})==='通过'?true:false} onChange={this.radioChange.bind(this, row,item)} value="1"/>,"通过",
                      <span style="padding-left: 15px">
                          <input type="radio" name={row.pqcitemid+''+item.comid+''} checked={this.getCrossCheckResultDesc({pqcitemid: row.pqcitemid, psucomid: item.comid})==='不通过'?true:false} onChange={this.radioChange.bind(this, row,item)} value="2"/></span>,"不通过"
                        //   <vxe-radio name={row.pqcitemid+''+item.comid+''} label="1" onChange={this.radioChange.bind(this, row,item)}>通过</vxe-radio>,
                        // <vxe-radio name={row.pqcitemid+''+item.comid+''} label="2" onChange={this.radioChange.bind(this, row,item)}>不通过</vxe-radio>
                      ]
                      } else {
                        return this.getCrossCheckResultDesc({pqcitemid: row.pqcitemid, psucomid: item.comid})
                      }
                    },
                    header: ({ column }) => {
                      return [
                        <span onClick={this.fileClick.bind(this,column,item)} style="color: #409EFF;padding-left:10px">{item.appendfilename}</span>
                    ]
                    }
                  }
                }
              ],
              showOverflow: true
            })
          }
        }
      },
      getCols () {
        this.cols = [
          {field: 'pqcitemchecktypedesc', fieldtype: 'C', title: '初审分类', calculExpr: '', addNewRowFlg: false, width: 100},
          {
            field: 'pqcitemcheckcontent', fieldtype: 'C', title: '初审内容', calculExpr: '', addNewRowFlg: false,
          }
          // {field: 'pqcitemcheckdemand', fieldtype: 'C', title: '采购文件要求', calculExpr: '', addNewRowFlg: false}
        ]
      },
      radioChange (row, column, e) {
        let pqcitemcheck = this.pqcitemcheckList.find(v => +v.pqcitemcheckpqcitemid === +row.pqcitemid && +v.pqcitemcheckcomid === +column.comid)
        if (pqcitemcheck) {
          let index = this.selectList.findIndex(v => +v.pqcitemcheckid === +pqcitemcheck.pqcitemcheckid)
          if(index === -1) {
            this.selectList.push({
              pqcitemcheckid: pqcitemcheck.pqcitemcheckid,
              pqcitemcheckpqcitemid: row.pqcitemid,
              pqcitemcheckcomid: column.comid,
              pqcitemcheckresult: e.target.value,
              pqccheckexpertid: this.$store.getters.expertLoginUser.pexpertid,
              pqccheckusertype: 2
            })
          } else {
            this.selectList[index].pqcitemcheckresult = e.target.value
          }
        }
      },
      async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/findProjectById',
          params: {projectid: this.$store.getters.expertLoginUser.pexpertprojectid}
        })
        this.project = res
        await this.initPqcitemcheck()
      },
      // 结果汇总表的数据
      async getPqcesList () {
        this.pqcesList = await request({
          url: 'expert/getPqcesByProjectId',
          method: "get",
          params: {
            pexpertid: this.$store.getters.expertLoginUser.pexpertid,
            projectid: this.$store.getters.expertLoginUser.pexpertprojectid
          }
        })
        this.pqcesList = this.pqcesList.map(v => {
          if (+v.pqcesresult === 1) {
            v.checked_1 = true
          }
          if (+v.pqcesresult === 2) {
            v.checked_2 = true
          }
          return v
        })
      }
    }
  }
</script>
<style lang="scss">
    .expqc-container {
        margin-top: 20px;
            .expqc-topbtn {
                display: flex;
                align-items: center;
                .expqc-topbtn-title {
                    padding-left: 10px;
                    text-align: center;
                }
                .expqc-topbtn-btn {
                    padding-left: 20px;
                }
            }
    }
    .expqc-footbtn {
        text-align: right;
        padding-top: 10px;
    }
</style>